import { render } from "./CustomSelectOneActiveStatus.vue?vue&type=template&id=b6655c1a"
import script from "./CustomSelectOneActiveStatus.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneActiveStatus.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__